import Headroom from 'headroom.js';
import Toggle from 'accessible-toggle';

const header = document.querySelector('.js-header');
const headerNav = document.querySelector('#header-nav');

if (header) {
  // Toggle navigation using hamburger menu
  const toggleText = header.querySelector('.js-toggle-text');
  const confNav = header.querySelector('.c-conf-nav');
  const toggle = new Toggle(headerNav, {
    closeOnClickOutside: true,
    trapFocus: true,
    onShow: () => {
      toggleText.innerText = 'Close';
      if (confNav) confNav.style.display = 'none';
    },
    onHide: () => {
      toggleText.innerText = 'Menu';
      if (confNav) confNav.style.display = 'block';
    },
  });

  setTimeout(() => {
    // Add padding to the top of the page to account for the header height
    const height = header.offsetHeight;
    document.body.style.paddingTop = `${height}px`;
    document.body.classList.add('is-loaded');

    // Show/hide the header based on scroll position and direction
    const headroom = new Headroom(header, {
      offset: 100,
      tolerance: 5,
      classes: {
        top: 'is-top',
        pinned: 'is-pinned',
        unpinned: 'is-unpinned',
        notTop: 'is-scrolled',
      },
      onUnpin: () => {
        toggle.hide();
      },
    });
    headroom.init();
  }, 0);
}
